import React from "react";

export default function SectionText() {
  return (
    <div>
      <div className="lg:px-[128px] px-[30px] text-xs text-[gray]">
        <p className=" lg:px-8 text-justify">
          1. Trade‑in values will vary based on the condition, year, and
          configuration of your eligible trade‑in device. Not all devices are
          eligible for credit. You must be at least the age of majority to be
          eligible to trade in for credit or for an Apple Gift Card. Trade‑in
          value may be applied toward qualifying new device purchase, or added
          to an Apple Gift Card. Actual value awarded is based on receipt of a
          qualifying device matching the description provided when estimate was
          made. Sales tax may be assessed on full value of a new device
          purchase. In‑store trade‑in requires presentation of a valid photo ID
          (local law may require saving this information). Offer may not be
          available in all stores, and may vary between in‑store and online
          trade‑in. Some stores may have additional requirements. Apple or its
          trade‑in partners reserve the right to refuse, cancel, or limit
          quantity of any trade‑in transaction for any reason. More details are
          available from Apple’s trade-in partner for trade‑in and recycling of
          eligible devices. Restrictions and limitations may apply.
        </p>

        <p className=" lg:px-8 text-justify mt-2">
          2.
          <span className="text-[#424242]">
            {" "}
            AT&T iPhone 16 Special Deal:
          </span>{" "}
          Monthly price (if shown) reflects net monthly payment, after
          application of AT&T trade-in credit applied over 36 months with
          purchase of an iPhone 16 Pro, iPhone 16 Pro Max, or iPhone 16, and
          trade-in of eligible smartphone. Receive credit with purchase of an
          iPhone 16 Pro or iPhone 16 Pro Max of either $1000, $830, or $350
          (based upon the model and condition of your trade-in smartphone).
          Receive credit with purchase of an iPhone 16 of either $800 or $350
          (based upon the model and condition of your trade-in smartphone). Max
          bill credits will not exceed the cost of the device. Requires upgrade
          of an existing line or activation of a new line and purchase of a new
          iPhone 16 Pro, iPhone 16 Pro Max, or iPhone 16, on qualifying 36 month
          0% APR installment plan, subject to carrier credit qualification.
          Customers purchasing this offer through Apple cannot add the Next Up
          Anytime option. $0 down for well qualified customers only, or down
          payment may be required and depends on a variety of factors. Tax on
          full retail price due at sale. Requires activation on eligible AT&T
          unlimited plan. AT&T may temporarily slow data speeds if the network
          is busy. If you cancel eligible wireless service, credits will stop
          and you will owe the remaining device balance. Activation/Upgrade Fee:
          $35. Trade in device may not be on existing installment plan. Bill
          credits are applied as a monthly credit over the 36 month installment
          plan. Credits start within 3 bills. Will receive catchup credits once
          credits start. Wireless line must be on an installment agreement,
          active, and in good standing for 30 days to qualify. Installment
          agreement starts when device is shipped. To get all credits, device
          must remain on agreement for entire term and you must keep eligible
          service on device for entire installment term. Limited time offer;
          subject to change. Limits: one trade-in per qualifying purchase and
          one credit per line. May not be combinable with other offers,
          discounts, or credits. Purchase, financing, other limits, and
          restrictions apply. Price for iPhone 16 and iPhone 16 Plus includes
          $30 AT&T connectivity discount. Activation required.
        </p>

        <p className=" lg:px-8 text-justify mt-2">
          Boost Mobile iPhone 16 Special Deal: Buy an iPhone 16 Pro, iPhone 16
          Pro Max, iPhone 16, or iPhone 16 Plus and get $1000 in bill credits
          (not to exceed the cost of the iPhone) applied over 36 months. No
          trade-in required. If you are trading in a device with this deal,
          trade-in value will be applied as additional bill credits over 36
          months. Monthly price (if shown) reflects net monthly payment, after
          application of $1000 in bill credit (not to exceed the cost of the
          iPhone purchased) and trade-in credit (if applicable) applied over 36
          months respectively. Requires activation of a new line, Boost Mobile
          Infinite Access plan and purchase on qualifying 36-month 0% APR
          installment plan, subject to carrier credit qualification. After
          making 12 installment payments, you may upgrade to a new iPhone and
          get up to $1000 in bill credits (not to exceed the cost of the iPhone)
          applied over 36 months for the new iPhone on the Infinite Access plan
          and purchase on new qualifying 36-month 0% APR installment plan,
          subject to carrier credit qualification. Tax on full retail price due
          at sale. If you cancel eligible wireless service, credits will stop
          and you will owe the remaining device balance. Bill credits are
          applied as a monthly credit over the 36-month installment plan.
          Trade-in credits start within 3 bills. Installment agreement starts
          when device is shipped. To get all credits, device must remain on
          agreement for entire term and you must keep eligible service on device
          for entire installment term. Limited-time offer; subject to change.
          Limits: one credit per line. May not be combined with other offers,
          discounts, or credits. Purchase, financing, other limits, and
          restrictions apply. Price for iPhone 16 and iPhone 16 Plus includes
          $30 Boost Mobile connectivity discount. Activation required.
        </p>

        <p className=" lg:px-8 text-justify mt-2">
          <span className="text-[#424242]">
            T‑Mobile iPhone 16 Special Deal:
          </span>{" "}
          Monthly price (if shown) reflects net monthly payment, after
          application of T‑Mobile trade-in credit applied over 24 months with
          purchase of an iPhone 16 Pro, iPhone 16 Pro Max, iPhone 16, or iPhone
          16 Plus and trade-in of eligible smartphone.
        </p>

        <p className=" lg:px-8 text-justify mt-2">
          Existing customers: Receive credit with purchase of an iPhone 16 Pro,
          iPhone 16 Pro Max, iPhone 16, or iPhone 16 Plus (based upon the model
          and condition of your trade-in smartphone) of $1000, $800, or $400 for
          customers on a Go5G Next plan (excluding 55, Military, First Responder
          plans); or $800 or $400 for customers on a Go5G Plus plan (excluding
          55, Military, First Responder plans); or $800, $600, or $300 for
          customers on a Go5G Next 55, Military, or First Responder plan; or
          $600 or $300 for customers on a Go5G Plus 55, Military, or First
          Responder plan; or $500 or $250 for customers on a Go5G, Magenta/MAX,
          or Essentials plan. Must be an existing T‑Mobile customer.
        </p>

        <p className=" lg:px-8 text-justify mt-2">
          New or Add-a-Line customers: Receive credit with purchase of an iPhone
          16 Pro, iPhone 16 Pro Max, iPhone 16, or iPhone 16 Plus (based upon
          the model and condition of your trade-in smartphone) of $1000, $800,
          or $400 for customers on a Go5G Next plan (excluding 55, Military,
          First Responder plans); or $800 or $400 for customers on a Go5G Plus
          plan (excluding 55, Military, First Responder plans); or $800, $600,
          or $300 for customers on a Go5G Next 55, Military, or First Responder
          plan; or $600 or $300 for customers on a Go5G Plus 55, Military, or
          First Responder plan; or $800 or $400 for customers on an Essentials,
          Simple Choice, TMO ONE/Plus, Magenta/MAX or Go5G plan (excluding 55,
          Military, First Responder plans); or $600 or $300 for customers on an
          Essentials 55 Choice, TMO ONE/Plus, Magenta/MAX & Go5G 55, Military,
          or First Responder plan. Must be a new T‑Mobile customer or adding a
          new line to an existing T‑Mobile account.
        </p>

        <p className=" lg:px-8 text-justify mt-2">
          Max bill credits will not exceed the cost of the device. Credit
          comprised of (i) Apple instant trade-in credit at checkout and (ii)
          T‑Mobile monthly bill credits applied over 24 months. Allow 2 bill
          cycles from valid submission and validation of trade-in. Tax on
          pre-credit price due at sale. Limited-time offer; subject to change.
          Qualifying credit, data plan, and trade-in in good condition required.
          Max 4 promotional offers on any iPhone per account. May not be
          combinable with some offers or discounts. Activation required. Contact
          T‑Mobile before cancelling service to continue remaining bill credits
          on current device, or credits stop & balance on required finance
          agreement is due.
        </p>

        <p className=" lg:px-8 text-justify mt-2">
          <span className="text-[#424242]">
            {" "}
            Verizon iPhone 16 Special Deal:
          </span>{" "}
          Monthly price (if shown) reflects net monthly payment, after
          application of Verizon trade-in credit applied over 36 months with
          purchase of an iPhone 16 Pro, iPhone 16 Pro Max, iPhone 16, or iPhone
          16 Plus.
        </p>

        <p className=" lg:px-8 text-justify mt-2">
          Existing customers: Customers on an Unlimited Ultimate plan receive
          $830 credit (based upon the model and condition of your trade-in
          smartphone) with purchase of an iPhone 16 Pro, iPhone 16 Pro Max,
          iPhone 16, or iPhone 16 Plus. Customers on an Unlimited Plus plan
          receive $415 credit (based upon the model and condition of your
          trade-in smartphone) with purchase of an iPhone 16 Pro, iPhone 16 Pro
          Max, iPhone 16, or iPhone 16 Plus. Must be an existing Verizon
          customer.
        </p>

        <p className=" lg:px-8 text-justify mt-2">
          New or Add-a-Line customers: Customers on an Unlimited Ultimate plan
          receive $830 credit (based upon the model and condition of your
          trade-in smartphone) with purchase of an iPhone 16 Pro, iPhone 16 Pro
          Max, iPhone 16, or iPhone 16 Plus. Customers on an Unlimited Plus plan
          receive $830 credit (based upon the model and condition of your
          trade-in smartphone) with purchase of an iPhone 16 Pro, iPhone 16 Pro
          Max, iPhone 16, or iPhone 16 Plus. Customers on an Unlimited Welcome
          plan receive $830 credit (based upon the model and condition of your
          trade-in smartphone) with purchase of an iPhone 16 Pro, iPhone 16 Pro
          Max, iPhone 16, or iPhone 16 Plus. Must be a new Verizon customer or
          adding a new line to an existing Verizon account.
          <br></br>
          <br></br>
          Max bill credits will not exceed the cost of the device. Credit
          comprised of (i) Apple instant trade-in credit at checkout and (ii)
          Verizon monthly bill credits applied over 36 months. Customer must
          remain in the Verizon Device Payment Program for 36 months to receive
          the full benefit of the Verizon bill credits. Bill credits may take
          1-2 bill cycles to appear. If it takes two cycles for bill credits to
          appear, you'll see the credit for the first cycle on your second bill
          in addition to that month's credit. Requires purchase and activation
          of a new iPhone 16 Pro, iPhone 16 Pro Max, iPhone 16, or iPhone 16
          Plus with the Verizon Device Payment Program at 0% APR for 36 months,
          subject to carrier credit qualification, and iPhone availability and
          limits. Taxes and shipping not included in monthly price. Sales tax
          may be assessed on full value of new iPhone. Requires eligible
          unlimited service plan. Requires trade-in of eligible device in
          eligible condition. Must be at least 18 to trade-in. Apple or its
          trade-in partners reserve the right to refuse or limit any trade-in
          transaction for any reason. In-store trade-in requires presentation of
          a valid, government-issued photo ID (local law may require saving this
          information). In-store promotion availability subject to local law;
          speak to a Specialist to learn more. Limited-time offer; subject to
          change. Additional terms from Apple, Verizon, and Apple's trade-in
          partners may apply. Price for iPhone 16 and iPhone 16 Plus includes
          $30 Verizon connectivity discount. Activation required.
        </p>

        <p className=" lg:px-8 text-justify mt-2">
          <span className="text-[#424242]">AT&T iPhone 15 Special Deal:</span>{" "}
          Buy an iPhone 15 128 GB and get $513.36 in bill credits applied over
          36 months. Buy an iPhone 15 256 GB and get $433.36 in bill credits
          applied over 36 months. Buy an iPhone 15 512 GB and get $453.36 in
          bill credits applied over 36 months. Requires upgrade of an existing
          line (or activation of a new line) and purchase on qualifying 36-month
          0% APR installment plan, subject to carrier credit qualification. $0
          down for well-qualified customers only, or down payment may be
          required and depends on a variety of factors. Tax on full retail price
          due at sale. Requires activation on eligible AT&T unlimited plan. AT&T
          may temporarily slow data speeds if the network is busy. If you cancel
          eligible wireless service, credits will stop and you will owe the
          remaining device balance. Activation/Upgrade Fee: $35. Bill credits
          are applied as a monthly credit over the 36-month installment plan.
          Credits start within 3 bills. Will receive catch-up credits once
          credits start. Wireless line must be on an installment agreement,
          active, and in good standing for 30 days to qualify. Installment
          agreement starts when device is shipped. To get all credits, device
          must remain on agreement for entire term and you must keep eligible
          service on device for entire installment term. Limited-time offer;
          subject to change. Limits: one credit per line. May not be combinable
          with other offers, discounts, or credits. Purchase, financing, other
          limits, and restrictions apply. Activation required.
        </p>

        <p className=" lg:px-8 text-justify mt-2 mb-6">
          To access and use all Apple Card features and products available only
          to Apple Card users, you must add Apple Card to Wallet on an iPhone or
          iPad that supports and has the latest version of iOS or iPadOS. Apple
          Card is subject to credit approval, available only for qualifying
          applicants in the United States, and issued by Goldman Sachs Bank USA,
          Salt Lake City Branch.
          <br></br>
          <br></br>
          If you reside in the U.S. territories, please call Goldman Sachs at
          877-255-5923 with questions about Apple Card.
          <br></br>
          <br></br>
          Learn more about how Apple Card applications are evaluated at{" "}
          <span className="text-[#424242] underline">
            support.apple.com/kb/HT209218.
          </span>
          <br></br>
          <br></br>
          Apple Intelligence is available in beta on all iPhone 16 models,
          iPhone 15 Pro, iPhone 15 Pro Max, iPad mini (A17 Pro), and iPad and
          Mac models with M1 and later, with Siri and device language set to
          Chinese (Simplified), English (Australia, Canada, India, Ireland, New
          Zealand, Singapore, South Africa, UK, or U.S.), French, German,
          Italian, Japanese, Korean, Portuguese (Brazil), or Spanish, as part of
          an iOS 18, iPadOS 18, and macOS Sequoia software update, with more
          languages coming over the course of the year, including Vietnamese.
          Some features may not be available in all regions or languages.
          <br></br>
          <br></br>A subscription is required for Apple Arcade, Apple Fitness+,
          Apple Music, and Apple TV+.
          <br></br>
          <br></br>
          Features are subject to change. Some features, applications, and
          services may not be available in all regions or all languages.
        </p>
      </div>
    </div>
  );
}
